export default __webpack_public_path__ + "static/media/welcome.9f2adf92.svg";